module.exports = __webpack_public_path__ + "static/img/zihibanner.ca5b818b.png";